'use strict';
{
    var app = angular.module('tf.process', [])

        .controller('processCtrl', ['$scope', '$state', '$http', 'userConfig', '$localStorage', 'uiGridConstants', 'uiGridExporterConstants', '$timeout', '$filter', function processController($scope, $state, $http, userConfig, $localStorage, uiGridConstants, uiGridExporterConstants, $timeout, $filter) {

            $scope.costOfCarryData = {
                costOfCarry : null
            };

            $scope.showErrorsOnly = true;
            $scope.clientSortType     = 'lastLogin';
            $scope.clientSortReverse  = true;
            $scope.clientFilter   = '';

            $scope.brokerSortType     = 'lastLogin';
            $scope.brokerSortReverse  = true;
            $scope.brokerFilter   = '';

            $scope.userSessions = [];
            $scope.statusLastUpdated = null;
            $scope.loginsLastUpdated = null;
            $scope.signUpLastUpdated = null;

            $scope.clientInfo = [];
            $scope.clientsLastUpdated = null;

            $scope.loadLogins = function() {
                $http.get('/tradefloor/api/sessions/summaries').then(function(response) {
                    var data = response.data;
                    $scope.userSessions = data;
                    $scope.loginsLastUpdated = new Date();
                });
            };

            $scope.loadClients = function() {
                $http.get('/tradefloor/api/client/summaries').then(function(response) {
                    var data = response.data;
                    $scope.clientInfo = data;
                    $scope.clientsLastUpdated = new Date();
                });
            };


            $scope.loadBackOfficeStatus = function() {
                $http.get('/tradefloor/api/backoffice', {}).then(function (response) {
                    var data = response.data;
                    $scope.backOffices = data;
                    $scope.statusLastUpdated = new Date();
                });
            };

            $scope.loadSignUpInfo = function() {
                $http.get('/tradefloor/api/client/signup/summaries/', {}).then(function (response) {
                    var data = response.data;
                    $scope.signUpSupport.data = data;
                    $scope.signUpLastUpdated = new Date();
                });
            };

            $scope.statisticsBroker = undefined;
            $scope.statisticsBrokers = [];
            $scope.rawStatistics = {};
            $scope.portfolioStatisticsData = [];
            $scope.positionStatisticsData = [];

            $scope.portfolioStatisticsDataOptions = {
                title : {
                    enable : true,
                    text : "Portfolios"
                },
                chart: {
                    type: 'lineChart',
                    height: 500,
                    margin : {
                        top: 10,
                        right: 30,
                        bottom: 50,
                        left: 30
                    },
                    lines : {
                        forceY : [0]
                    },
                    x : function (d){return d[0];},
                    y : function (d){return d[1];},
                    yAxis : {
                        axisLabel : 'Count',
                        tickFormat : function(v) {
                            return d3.format('0f')(v);
                        }
                    },
                    xAxis: {
                        axisLabel: 'As At',
                        tickFormat: function(v) {
                            return d3.time.format('%d/%m/%y')(new Date(v));
                        }
                    },

                    showControls: true,
                    showValues: true,
                    transitionDuration: 750,
                    useInteractiveGuideline: true

                }
            };

            $scope.positionStatisticsDataOptions = {
                title : {
                    enable : true,
                    text : "Positions"
                },
                chart: {
                    type: 'lineChart',
                    height: 500,
                    margin : {
                        top: 10,
                        right: 30,
                        bottom: 50,
                        left: 30
                    },
                    lines : {
                        forceY : [0]
                    },
                    x : function (d){return d[0];},
                    y : function (d){return d[1];},
                    yAxis : {
                        axisLabel : 'Count',
                        tickFormat : function(v) {
                            return d3.format('0f')(v);
                        }
                    },
                    xAxis: {
                        axisLabel: 'As At',
                        tickFormat: function(v) {
                            return d3.time.format('%d/%m/%y')(new Date(v));
                        }
                    },

                    showControls: true,
                    showValues: true,
                    transitionDuration: 750,
                    useInteractiveGuideline: true

                }
            };

            $scope.selectBrokerStatistics = function(brokerName) {
                $scope.statisticsBroker = brokerName;

                var data = $scope.rawStatistics[brokerName];

                var totalPortfolios = {
                    key : 'Total Portfolios',
                    area : true,
                    disabled : true,
                    values : data.map(function(d) {
                        return [new Date(d.asAt), d.totalPortfolios];
                    })
                };
                var activePortfolios = {
                    key : 'Active Portfolios',
                    area : true,
                    values : data.map(function(d) {
                        return [new Date(d.asAt), d.activePortfolios];
                    })
                };
                var tradedPortfolios = {
                    key : 'Traded Portfolios',
                    area : true,
                    values : data.map(function(d) {
                        return [new Date(d.asAt), d.tradedPortfolios];
                    })
                };

                $scope.portfolioStatisticsData = [
                    totalPortfolios,
                    activePortfolios,
                    tradedPortfolios
                ];


                var totalPositions = {
                    key : 'Total Positions',
                    area : true,
                    values : data.map(function(d) {
                        return [new Date(d.asAt), d.positions];
                    })
                };

                var tradedPositions = {
                    key : 'Traded Positions',
                    area : true,
                    values : data.map(function(d) {
                        return [new Date(d.asAt), d.trades];
                    })
                };
                $scope.positionStatisticsData = [
                    tradedPositions,
                    totalPositions
                ];
            };

            $scope.loadStatistics = function() {
                $http.get('/tradefloor/api/backoffice/statistics').then(function(response) {
                    var data = response.data;

                    $scope.statisticsBrokers = Object.keys(data);
                    $scope.statisticsBrokers.sort();
                    $scope.rawStatistics = data;

                    $scope.selectBrokerStatistics($scope.statisticsBrokers[0]);
                });
            };

            $scope.loadClients();
            $scope.loadLogins();
            $scope.loadBackOfficeStatus();

            $http.get('/tradefloor/api/backoffice/coc').then(function (response) {
                var data = response.data;
                $scope.costOfCarryData.costOfCarry = data;
            });

            var startDate = new Date();
            startDate.setDate(startDate.getDate() - 6);

            $scope.exportCsv = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
            };

            $scope.exportCsvVisible = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
            };

            $scope.signUpSupport = {
                flatEntityAccess : true,
                enableGridMenu: false,
                enableColumnResizing: true,
                enableFiltering: true,
                minRowsToShow : 15,
                enablePaging : false,
                showFooter: true,
                showColumnFooter: true,
                excessRows : 20,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                exporterCsvFilename: 'signUpInfo.csv',
                onRegisterApi: function(gridApi){
                    $scope.gridApi = gridApi;
                },
                columnDefs : [
                    {
                        name: 'userName',
                        type : 'string',
                        enableFiltering: true,
                        displayName: 'User Name',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'displayName',
                        type : 'string',
                        enableFiltering: true,
                        displayName: 'Display Name',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'created',
                        enableFiltering: true,
                        displayName: 'Created',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true,
                        cellFilter : 'date : \'short\'',
                        sort: {
                            direction: uiGridConstants.DESC,
                            priority: 1
                        }
                    },
                    {
                        name: 'createdBy',
                        field : 'createdByDisplayName',
                        enableFiltering: true,
                        displayName: 'Created By',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'backOffice',
                        enableFiltering: true,
                        displayName: 'Back Office',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'recentLoginCount',
                        type : 'number',
                        cellFilter : 'number : 0',
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber',
                        enableFiltering: true,
                        displayName: 'Recent Logins',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'portfolios',
                        type : 'number',
                        cellFilter : 'number : 0',
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber',
                        enableFiltering: true,
                        displayName: 'Portfolios',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'portfoliosWithPositions',
                        type : 'number',
                        cellFilter : 'number : 0',
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber',
                        enableFiltering: true,
                        displayName: 'Portfolios With Positions',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    },
                    {
                        name: 'unlinkedPortfolios',
                        type : 'number',
                        cellFilter : 'number : 0',
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber',
                        enableFiltering: true,
                        displayName: 'Scratch Portfolios',
                        enableSorting: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        enableColumnResizing: true
                    }
                ]

            };

            $scope.exportCsv = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
            };

            $scope.exportCsvVisible = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
            };

            $scope.updateCostOfCarry = function() {
                var form = this.cocForm;
                $http.post('/tradefloor/api/backoffice/coc', $scope.costOfCarryData.costOfCarry).then(function() {
                    form.$setPristine();
                    form.$setUntouched();
                });
            }

        }]);
}
